import { t } from '@/utils/i18n'
import { constant } from '@/utils'
import IconShippingDefault from '@/assets/img/icon/icon-shipping-default.png'
import IconShipping from '@/assets/img/icon/icon-shipping.png'
import styles from './index.module.less'

const {
  order: { ShipType },
} = constant

function ShippingTypeLabel({
  shippingType,
  className,
  styleType = 'default',
}: {
  shippingType: number | null
  className?: string
  styleType?: 'primary' | 'default'
}) {
  const deliveryTypeLabel =
    shippingType === null
      ? t('海外发货')
      : shippingType === ShipType.OVER_SEA
      ? t('海外发货')
      : t('国内发货')

  const classNameList = `${styles['icon-wrap']} ${styleType === 'default' ? styles['default'] : styles['primary']} ${className}`
  
  return (
    <>
      <span className={classNameList}>
        <img src={styleType === 'default' ? IconShippingDefault : IconShipping} alt={deliveryTypeLabel} />
        {deliveryTypeLabel}
      </span>
    </>
  )
}

export default ShippingTypeLabel
